import { Project } from '../types/project';

export const normalizeProjectStatus = (status: Project['status']) => {
  if (!status) {
    return '';
  }
  return status.charAt(0).toUpperCase() + status.slice(1);
};
